import { createStyles } from '@mantine/core';
				
export const useStyles = createStyles((theme) => ({
		
  wrapper: {
    width : "55%",
    marginLeft : "45%",
    display : "flex",
    justifyContent : "left",
    columnGap : "45%",
    marginTop : 20,
    [theme.fn.smallerThan(1000)] : {
      width : "100%",
      marginLeft: 0,
      justifyContent : "space-between",
      columnGap : 0,
      paddingLeft : 20,
      paddingRight  :20
    }
  },
  logo : {
    width : 150,
    [theme.fn.smallerThan(600)] : {
      width : 120
    }
  },
  btn : {
    background : theme.colors.secondary[0],
    fontFamily : `Light, ${theme.fontFamily}`,
    height : 45,
    fontSize : 12,
    letterSpacing : 1,
    width : 100,
    
    ":hover" : {
      background : theme.colors.primary[0]
    }
  },
		
  nodisplay: {		
    visibility: 'hidden',		
    [theme.fn.smallerThan(500)]: {		
      display: 'none'		
    }		
  }
		
}));